import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { getPartes } from '../../api/client'
import { formatFecha } from '../unidades/tipos'

// Column of the Partes board shown as each parte's description, if it has one.
const DESCRIPCION = 'Detalles'

// A unit's partes, newest first -- its maintenance record. Each one opens in
// the Partes section, on that parte's panel (/operations/partes?parte=<id>).
export default function PartesDeUnidad({ unidadId }) {
  const { t } = useTranslation('engineering')
  const navigate = useNavigate()
  const [partes, setPartes] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let vivo = true
    getPartes({ unidad_id: unidadId, incluir_atributos: true })
      .then(ps => { if (vivo) { setPartes(ps); setError('') } })
      .catch(() => { if (vivo) setError(t('partes.loadFailed')) })
    return () => { vivo = false }
  }, [unidadId, t])

  if (error) return <p className="text-red-500 text-sm">{error}</p>
  if (!partes) return <p className="text-gray-400 text-sm">{t('unidades.loading')}</p>
  if (!partes.length) return <p className="text-gray-400 text-sm text-center py-10">{t('partes.deUnidad.empty')}</p>

  return (
    <ul className="space-y-2">
      {partes.map(p => {
        const detalle = p.atributos?.[DESCRIPCION]
        return (
          <li key={p.id}>
            <button type="button" onClick={() => navigate(`/operations/partes?parte=${p.id}`)}
              title={t('partes.deUnidad.open')}
              className={`w-full text-left rounded-lg border px-3 py-2.5 transition-colors hover:bg-gray-50 ${
                p.abierto ? 'border-amber-300 bg-amber-50/40' : 'border-gray-200'}`}>
              <div className="flex items-start justify-between gap-3">
                <p className="text-sm font-medium text-gray-900 min-w-0">
                  <span className="text-gray-400 tabular-nums">#{p.numero}</span> {p.nombre}
                </p>
                <div className="flex items-center gap-1.5 shrink-0">
                  {p.implica_fs && <span className="px-1.5 py-0.5 rounded-full text-[11px] font-semibold bg-red-100 text-red-800">F/S</span>}
                  {p.abierto
                    ? <span className="px-2 py-0.5 rounded-full text-[11px] font-medium bg-amber-100 text-amber-800">{t('partes.abierto')}</span>
                    : <span className="px-2 py-0.5 rounded-full text-[11px] font-medium bg-green-100 text-green-800">{t('partes.cerrado')}</span>}
                </div>
              </div>
              {detalle && <p className="text-xs text-gray-600 mt-1 line-clamp-2 whitespace-pre-line">{detalle}</p>}
              <p className="text-[11px] text-gray-400 mt-1 tabular-nums">
                {t('partes.deUnidad.fechas', { apertura: formatFecha(p.fecha_apertura) })}
                {p.fecha_cierre && ` · ${t('partes.deUnidad.cierre', { cierre: formatFecha(p.fecha_cierre) })}`}
              </p>
            </button>
          </li>
        )
      })}
    </ul>
  )
}
